import { updateSessionValue } from './sessionValue'

export default function clearSessionToken(): void {
  updateSessionValue(null)
  // ls.removeItem(VITE_BACKEND_JWT_LS_KEY)
}
